import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const Wrapper = styled.div``;
const LinkText = styled.div`
  font-family: NotoSansTC-Medium;
  cursor: pointer;
  span {
    margin-left: 8px;
  }
`;

interface IProps {
  returnPageName: string;
  returnPageUrl?: string;
  onClikcReturnPage?: () => void;
}

/**
 * 網站麵包屑。
 */
const Breadcrumb: React.FC<IProps> = ({ returnPageName, returnPageUrl, onClikcReturnPage }) => {
  return (
    <>
      {onClikcReturnPage === undefined ? (
        <Wrapper>
          <Link to={returnPageUrl || process.env.PUBLIC_URL}>
            <LinkText>
              <FaArrowLeft />
              <span>返回{returnPageName}</span>
            </LinkText>
          </Link>
        </Wrapper>
      ) : (
        <Wrapper onClick={onClikcReturnPage}>
          <LinkText>
            <FaArrowLeft />
            <span>返回{returnPageName}</span>
          </LinkText>
        </Wrapper>
      )}
    </>
  );
};

export default Breadcrumb;
